import { IconButton, PlusIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type EmailTemplateListHeaderProps = {
  onCreate: () => void;
  isCreateDisabled?: boolean;
};

export const EmailTemplateListHeader: FC<EmailTemplateListHeaderProps> = ({ onCreate, isCreateDisabled = false }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col gap-4 rounded-2xl border border-secondary-border bg-white p-4 lg:flex-row lg:items-start lg:justify-between'>
      <div className='space-y-2'>
        <h2 className='text-2xl font-semibold text-slate-900'>{t('emailWorkspace.templates.templateListTitle')}</h2>
        <p className='max-w-2xl text-sm text-secondary-600'>{t('emailWorkspace.templates.templateListDescription')}</p>
      </div>
      <IconButton
        leadingIcon={<PlusIcon className='size-5 text-white-100' />}
        className='inline-flex w-full max-w-[220px] justify-center'
        onClick={onCreate}
        text={t('emailWorkspace.templates.createEmailTemplate')}
        disabled={isCreateDisabled}
      />
    </div>
  );
};
